
import { Container } from '@mui/material';


export default function GestEmpresas({ element: component, ...rest }) {

    return (
            <Container>
                {component}
            </Container>
    )
}